/*
 * @Author: 顾喜斌 xibin_gu@163.com
 * @Date: 2023-01-17 14:46:18
 * @LastEditors: 顾喜斌 xibin_gu@163.com
 * @LastEditTime: 2023-02-01 23:12:09
 */
import {request} from '../utils/request'

/**
 * 获取重定向地址
 * @param {*} params 
 * @returns 
 */
export function getCodeAndRedirect(params={}) {
    return request({
        url: '/h5/frontUser/getCodeAndRedirect',
        method: 'get',
        params
    })
}
/**
 * 获取签名权限
 * @param {*} params 
 * @returns 
 */
export function createSignature(data={}) {
    return request({
        url: '/h5/frontUser/getTrdConfig',
        method: 'post',
        data
    })
}
/**
 * 是否在微信小程序打开
 * @param {*} params 
 * @returns 
 */
export function whetherOpenInWxMiniApp(data={}) {
    return request({
        url: '/h5/frontUser/whetherOpenInWxMiniApp',
        method: 'post',
        data
    })
}
/**
 * 获取微信小程序APPID
 * @param {*} params 
 * @returns 
 */
export function wxMiniAppId(data={}) {
    return request({
        url: '/h5/frontUser/getWxMiniAppId',
        method: 'post',
        data
    })
}
/**
 * 获取微信小程序scheme
 * @param {*} params 
 * @returns 
 */
export function generatescheme(data={}) {
    return request({
        url: '/h5/ma/user/generatescheme',
        method: 'post',
        data
    })
}
/**
 * 获取支付宝小程序APPID
 * @param {*} params 
 * @returns 
 */
export function getAliMiniAppId(data={}) {
    return request({
        url: '/h5/frontUser/getAliMiniAppId',
        method: 'post',
        data
    })
}
/**
 * 获取是否需要关注微信公众号
 * @param {*} params 
 * @returns 
 */
export function getNeedFollowWxmp(data={}) {
    return request({
        url: '/h5/frontUser/getNeedFollowWxmp',
        method: 'post',
        data
    })
}
/**
 * 生成ticket
 * @param {*} params 
 * @returns 
 */
export function setTicket(data={}) {
    return request({
        url: '/h5/frontUser/getTicket',
        method: 'post',
        data
    })
}
/**
 * 获取ticket内容
 * @param {*} params 
 * @returns 
 */
export function getTicket(data={}) {
    return request({
        url: '/h5/frontUser/getTicketContent',
        method: 'post',
        data
    })
}